import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const UCLA = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="University of California, Los Angeles"
      universityShortName="UCLA"
      slug="ucla"
      seoTitle="UCLA Study Rooms | Young Research Library Study Spaces"
      seoDescription="Find study rooms at UCLA including YRL and Powell Library. Learn booking policies, quiet zones, and discover CSW as an online alternative."
      seoKeywords="UCLA study rooms, Young Research Library, Powell Library, Westwood study spaces, Bruin study rooms"
      canonicalUrl="/study-room/ucla/"
      heroDescription="Explore UCLA's iconic libraries from historic Powell to modern Young Research Library."
      libraryWebsiteUrl="https://www.library.ucla.edu"
      libraryWebsiteName="UCLA Library"
      studySpaces={[
        {
          name: "Young Research Library (YRL) - Group Rooms",
          features: "Rooms seat 6-8 with monitors. 3 hours/day, 6 hours/week max. Book 3 days ahead.",
          feedback: "Self-service with QR codes. Not soundproof - keep voices down."
        },
        {
          name: "YRL - Individual Study Rooms",
          features: "Drop-in only, first-come-first-served.",
          feedback: "Good for solo work when group rooms are full."
        },
        {
          name: "Powell Library - Charles E. Young Reading Room",
          features: "Historic reading room, designated silent study.",
          feedback: "Beautiful space. Very quiet and focused atmosphere."
        },
        {
          name: "Court of Sciences Student Center",
          features: "Outdoor tables, fresh air study option.",
          feedback: "Great for a change of scenery. Weather dependent."
        }
      ]}
      guideContent={
        <>
          <p>
            The Young Research Library (YRL) has group study rooms seating 6-8 students with monitors. Students, faculty 
            and staff may reserve one room for up to three hours per day and six hours per week, up to three days in advance.
          </p>
          <p className="mt-4">
            Some rooms are self-service with QR codes posted at the door to verify reservations. Individual study rooms 
            are drop-in only. Students note that YRL study rooms are not soundproof, so conversations from adjacent rooms 
            can be distracting.
          </p>
          <p className="mt-4">
            Reserve a YRL room early in the week and keep your voice down. For silence, head to the Charles E. Young 
            Reading Room in Powell Library or the top floor of YRL. If you need fresh air, the Court of Sciences 
            Student Center offers outdoor tables.
          </p>
        </>
      }
      summaryTips={[
        "Book YRL rooms up to 3 days in advance",
        "Max 3 hours/day, 6 hours/week per person",
        "Rooms not soundproof - keep voices low",
        "Powell Reading Room is historic and silent",
        "Individual rooms are drop-in only"
      ]}
    />
  );
};

export default UCLA;
